var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageTabPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.808,
    viewBox: "0 0 12 7.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 106",
    d: "M3.6 5.406A2.4 2.4 0 1 1 6 7.808a2.4 2.4 0 0 1-2.4-2.402zm6.372-2.117A4.41 4.41 0 0 0 6 1.2a4.417 4.417 0 0 0-3.974 2.089 6.028 6.028 0 0 0-.833 2.194L0 5.332a7.138 7.138 0 0 1 .987-2.645A5.607 5.607 0 0 1 6 0a5.6 5.6 0 0 1 5.014 2.687A7.126 7.126 0 0 1 12 5.332l-.6.074-.6.077a6 6 0 0 0-.828-2.194z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTabPreviewIcon);
export default __webpack_public_path__ + "static/media/imageTabPreviewIcon.e896d298216cdfe2acc0ed2ebd75fc44.svg";
export { ForwardRef as ReactComponent };